import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SigninPopupPageRoutingModule } from './signin-popup-routing.module';

import { SigninPopupPage } from './signin-popup.page';


import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { LanguageService } from 'src/app/services/language.service';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../../../environments/environment.prod'

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.i18n, '.json');
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SigninPopupPageRoutingModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      isolate: true
    }),
  ],
  declarations: [SigninPopupPage]
})
export class SigninPopupPageModule {
  language$ = this.languageService.language$;
  constructor(
    private translateService: TranslateService,
    private languageService: LanguageService,
  ) {
    this.language$.pipe(map(language => language.lang)).subscribe(lang => this.translateService.use(String(lang)));
  }
}
